import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AboutUs } from './components/AboutUs';
import { Services } from './components/Services';
import { CaseStudies } from './components/CaseStudies';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutUs data-id="element-4" />
        <Services data-id="element-5" />
        <CaseStudies data-id="element-6" />
        <Testimonials data-id="element-7" />
        <CallToAction data-id="element-8" />
        <Contact data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}